import * as _ from 'es6-polyfill';
import Vue from 'vue';
import router from './router';
import store from './store';

import App from './App.vue';
import observable from './directives/observable';
// Styles
import './assets/styles/scss/main.scss';

Vue.config.productionTip = false;
Vue.directive('observable', observable);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');

window.scrollTo(0, 0);
